import React from 'react';
import { useTranslation } from 'react-i18next';

import { GeneralSelect } from 'sharedComponents/GeneralSelect';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { IconEnvelope, IconGlobe, IconPTUser } from 'svgIcons/MotionPortalIcons';
import {
    formatLanguages,
    formatSelectedLanguage,
} from './helpers';

import './style.scss';
import localStorageHelper from 'helpers/localStorageHelper';


const UserProfileComponent = ({
    model: {
        user,
        userLoadingStatus,
        availableLanguagesLoadingStatus,
        availableLanguages
    },
    actions
}) => {
    const userRoles = localStorageHelper.getItem('user');
    const roles = userRoles?.userRoles ?? [];
    const { t: translate } = useTranslation();
    const selectedLanguage = user.data.languageCode;

    return <div className='user-profile-settings-content component_profile'>
        <div className='user-profile-settings-content-header'>{translate('ABB.Powertrain.Frontend.userProfileSettingProfile')}</div>
        <div className='profile-settings'>
            <LoadingStatusWrapper
                debounce={false}
                loadingStatus={[userLoadingStatus, availableLanguagesLoadingStatus]}
                transparent
                fullScreen >
                <div className='profile-item-wrapper'>
                    <div className='item'>{translate('ABB.Powertrain.Frontend.searchPlaceholderNameText')}</div>
                    <div className='value input-like'>
                        <IconPTUser width='20' height='20' style={{ marginRight: 8 }} />
                        {`${user.data?.firstName} ${user.data?.lastName}`}
                    </div>
                </div>
                <div className='profile-item-wrapper'>
                    <div className='item'>{translate('ABB.Powertrain.Frontend.userRoleLabel')}</div>
                    <div className='value input-like'>
                        {Array.isArray(roles) && roles?.length > 0
                            ? roles.map(role => role?.name).join(', ')
                            : '-'}
                    </div>
                </div>
                <div className='profile-item-wrapper'>
                    <div className='item'>{translate('ABB.Powertrain.Frontend.emailLabel')}</div>
                    <div className='value input-like'>
                        <IconEnvelope width='20' height='20' style={{ marginRight: 8 }} />
                        {user.data?.email}
                    </div>
                </div>
                <div className='profile-item-wrapper'>
                    <div className='item'>{translate('ABB.Powertrain.Frontend.languageLabel')}</div>
                    <div className='value language-input-like language-select-dropdown'>
                        <GeneralSelect
                            inputId='profile-language-select'
                            name='profile-language-select'
                            id='language_dropdown'
                            getOptionLabel={option => option.label}
                            getOptionValue={option => option.id}
                            isSearchable={false}
                            value={formatSelectedLanguage(selectedLanguage, availableLanguages)}
                            options={formatLanguages(availableLanguages)}
                            onChange={(languageCode) => {
                                actions.updateSelectedLanguage(languageCode.id);
                            }}
                            leftIcon={<IconGlobe width='20' height='20' />}
                        />
                    </div>
                </div>
                <div className='profile-item-wrapper'>
                    <a className='remove-account-link' href='#'>
                        {translate('ABB.Powertrain.Frontend.removeAccountLabel')}
                    </a>
                </div>
            </LoadingStatusWrapper>
        </div>
    </div>;
};

export default UserProfileComponent;
